import { browserOrNode, isWebWorker } from '@aws-amplify/core';
var getDefaultAdapter = function () {
    var isBrowser = browserOrNode().isBrowser;
    if ((isBrowser && window.indexedDB) || (isWebWorker() && self.indexedDB)) {
        return require('../indexeddb').default;
    }
    var AsyncStorageAdapter = require('../asyncstorage').AsyncStorageAdapter;
    return new AsyncStorageAdapter();
};
export default getDefaultAdapter;
//# sourceMappingURL=index.js.map